// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-form-viewer-container .btn-group .btn {
  height: 34px;
}`, "",{"version":3,"sources":["webpack://./Source/app/fi-form/fi-form-viewer/fi-form-viewer-container.component.scss"],"names":[],"mappings":"AAEQ;EACI,YAAA;AADZ","sourcesContent":[".fi-form-viewer-container {\r\n    .btn-group {\r\n        .btn {\r\n            height: 34px;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
